<template>
    <div id="preloader" ref="preloader" layout="row center-center">
        <!--<svg ref="dot" id="dot" width="5%" height="5%" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;">-->
        <!--<g transform="matrix(1,0,0,1,-1486.56,-730)">-->
        <!--<g id="cursor" transform="matrix(0.6,0,0,0.6,41.1587,440.2)">-->
        <!--<circle cx="2419" cy="493" r="10" style="fill:rgb(0,195,255);"/>-->
        <!--</g>-->
        <!--</g>-->
        <img ref="dot" id="dot" src="@/assets/dot.svg"/>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {TweenMax, Sine} from 'gsap';

    export default {
        name: "Preloader",
        data() {
            return {}
        },
        methods: {
            load(next) {

                const preloader = this.$refs.preloader;
                const dot = this.$refs.dot;

                preloader.style.top = 0;
                preloader.style.bottom = null;

                dot.style.opacity = 0;

                TweenMax.to(preloader, 0.4, {
                    height: '100vh',
                    ease:Sine.easeIn,
                    onComplete: () => {
                        this.startDot();
                        if (next) {
                            next();
                        }
                    }
                });
            },
            hide() {
                return new Promise((resolve, reject) => {
                    this.stopDot(() => {
                        const preloader = this.$refs.preloader;
                        preloader.style.top = null;
                        preloader.style.bottom = 0;
                        TweenMax.to(preloader, 0.4, {
                            height: '0vh',
                            delay: 0,
                            ease: Sine.easeOut,
                            onComplete: () => {
                                resolve();
                            }
                        });
                    });
                });
            },
            startDot() {

                const dot = this.$refs.dot;
                TweenMax.to(dot, 0, {scale:1});
                TweenMax.to(dot, 0.5, {opacity: 1});
                TweenMax.to(dot, 0.6, {
                    scale: 1.5, yoyo: true, repeat: -1
                });
            },
            stopDot(callback) {
                const dot = this.$refs.dot;
                TweenMax.to(dot, 0.5,  {
                    opacity: 0, ease: Sine.easeIn, delay:0.5, onComplete: () => {
                        TweenMax.killTweensOf(dot);
                        if (callback) {
                            callback();
                        }
                    }
                });
            }
        },
        created() {
            Vue.prototype.$preloader = this;
           // document.body.style.background = 'white';
        },
        mounted() {
        }
    }
</script>

<style lang="scss" scoped>
    #preloader {
        position: fixed;
        bottom: 0;
        left: 0;
        background-color: black;
        height: 100vh;
        z-index: 100;

    }

    #dot {
        opacity: 0;
        width: 4%;
        height: 4%;
    }
</style>
